import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";

const ConditionDesignerModal = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  //const OnCloseModal = props.OnCloseModal;
  const OnClickType = props.OnClickType;

  //State
  const [loading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variables
  const listType = [
    "if",
    "sensor"
  ];


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "500px", minHeight: "0px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ConditionDesigner", "Select your condition type")}
        </div>
          {listType.map((t, index) => (
            <div className="conditiondesigner_type" key={index}>
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("ConditionDesigner", "type:" + t)}
                style={{ maxWidth: "200px" }}
                onClick={() => OnClickType(t)}
                disabled={loading}
              />
            </div>
          ))}
        {/* <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div> */}
      </div>
    </div>
  );

};

export default ConditionDesignerModal